import type { ChatComposerLabels } from './chat-composer-types.ts';

/**
 * The composer's copy with every gap filled, so each control gets a string.
 * `removeAttachment` stays unset when missing, leaving the chip its own
 * default; the stop button falls back to the send label.
 */
export function composerLabels(
  labels: ChatComposerLabels | undefined,
  sendLabel: string,
) {
  return {
    attach: labels?.attach ?? '',
    removeAttachment: labels?.removeAttachment,
    dictate: labels?.dictate ?? '',
    dictateStop: labels?.dictateStop ?? sendLabel,
    dictateSending: labels?.dictateSending ?? '',
    dictateCancel: labels?.dictateCancel ?? '',
    dictateMicrophone: labels?.dictateMicrophone ?? '',
    dictateOptions: labels?.dictateOptions ?? '',
  };
}
